import * as React from 'react';

import { UXFB_EVENT_COMPARE_ZHK } from '../../constants/uxfb';
import { sendUXSEventWhenReady } from '../../utils/uxs';

export type TUxfbPlatform = 'desktop' | 'mobweb';

/**
 * Шлёт UXFB-событие `compare_zhk` один раз за заход на страницу сравнения ЖК.
 * `enabled` — есть ли данные сравнения: пока страница не показана, событие не шлём.
 */
export function useCompareZhkUxfbEvent(platform: TUxfbPlatform, enabled: boolean): void {
  const hasSentRef = React.useRef(false);

  React.useEffect(() => {
    if (!enabled || hasSentRef.current) {
      return;
    }

    hasSentRef.current = true;
    sendUXSEventWhenReady(UXFB_EVENT_COMPARE_ZHK, { platform });
  }, [platform, enabled]);
}
